import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import RadioButtons, { RadioButtonsProps } from '../common/radio-buttons'

type Props<IFormValues extends FieldValues, IdType> = Omit<RadioButtonsProps<IdType>, 'value' | 'onChange'> & {
    name: Path<IFormValues>
    control: Control<IFormValues, any>
}

const ControlledRadioButtons = <IFormValues extends FieldValues, IdType>({ name, control, ...rest }: Props<IFormValues, IdType>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <RadioButtons error={fieldState.error?.message as any} {...field} onChange={(value) => field.onChange(value as any)} {...rest}></RadioButtons>
            )}
        />
    )
}

export default ControlledRadioButtons
